import { render, staticRenderFns } from "./barechart.vue?vue&type=template&id=3dbb0d2e&scoped=true&"
import script from "./barechart.vue?vue&type=script&lang=js&"
export * from "./barechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb0d2e",
  null
  
)

export default component.exports